import React, { useEffect, useCallback } from "react";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";

import { useDispatch, useSelector } from "react-redux";

import { columns } from "./columns";

import { Home } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";

import { PAYMENTS_PHRASE } from "./config";

import { PaymentsTableInputs } from "./PaymentsTableInputs";

import {
  clearPayments,
  handlePaymentsInputsAction,
  fetchPayments,
} from "redux/actions/buildings/payments/paymentsActions";

export const PaymentsPage = () => {
  const dispatch = useDispatch();

  const {
    setSnackbar,
    clearSearch,
    buildCompLoadings
  } = useSearch();
  const { payments, accountSelected } = useSelector(state => state.payments);
  const { isLoadingComp } = useSelector(state => state.search);

  const handleSubmit = useCallback(() => {
    if (!accountSelected) {
      setSnackbar(PAYMENTS_PHRASE.page.table.header.snackBar);
      return;
    }

    dispatch(fetchPayments(accountSelected.id));
  }, [accountSelected, setSnackbar]);

  const submitMemoized = useCallback((e) => {
    e.preventDefault();
    handleSubmit();
  }, [handleSubmit]);

  useEffect(() => {
    clearSearch();
    dispatch(clearPayments());
  }, [clearSearch]);

  useEffect(() => {
    buildCompLoadings([
      "fetchSyncCycle",
      "fetchCloseCycle",
      "fetchCaptures",
      "fetchRouteCycles",
      "fetchEditCapture",
      "fetchCancelCapture"
    ]);
  }, []);

  return (
    <React.Fragment>
      <CardTable
        data={payments}
        columns={columns}
        loading={isLoadingComp?.fetchCaptures}
        title={PAYMENTS_PHRASE.page.table.title}
        icon={<Home />}
        hasHeader
        tableContent={
          <TableInputs
            reducer="payments"
            stations
            dispatchAction={handlePaymentsInputsAction}
            submitAction={submitMemoized}
          >
            <PaymentsTableInputs />
          </TableInputs>
        }
        blockBtn
      />
    </React.Fragment>
  );
};
